import { GlobalDashboardPage } from "@/features/dashboard/GlobalDashboardPage";
import { useAppShell } from "@/shell/app-shell-context";

import { useRequireCompany } from "@/shared/hooks/useRequireCompany";
/**
 * O dashboard vive DENTRO da empresa (`/empresas/:companyId/dashboard`)
 * e não mais na raiz: o `X-Company-Id` que o client manda sai da URL
 * (`extractCompanyId` no `AppShellProvider`), então fora desse caminho a
 * API não saberia de quem é o recorte.
 */
export function CompanyDashboardRoute() {
  const { token, openMention } = useAppShell();
  const company = useRequireCompany();

  if (!company) return null;

  // `openMention` para as menções em destaque abrirem o drawer que já
  // existe — mesma razão do relatório: a publicação é a mesma, só vista
  // de outro lugar.
  return (
    <GlobalDashboardPage
      token={token}
      companyId={company.id}
      openMention={openMention}
    />
  );
}
